import React from "react";

import { useParams } from "react-router-dom";

import BidsTable from "../components/BidsTable";

const Bids = () => {

  const params = useParams();

  return <BidsTable id={params.id} />;
}

export default Bids;